import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { PageComponent } from "@components/page/page.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent, TabsComponent as TabsComponent_1 } from "@components/tabs/tabs.component";

import { CanBeDirty } from "~app/common/guards/dirty.guard";
import { SysadmArbetsorderComponent } from "./tabs/sysadm-arbetsorder/sysadm-arbetsorder.component";
import { SysadmAvverkningsanmalanComponent } from "./tabs/sysadm-avverkningsanmalan/sysadm-avverkningsanmalan.component";
import { SysadmChecklistaComponent } from "./tabs/sysadm-checklista/sysadm-checklista.component";
import { SysadmEudrComponent } from "./tabs/sysadm-eudr/sysadm-eudr.component";
import { SysadmFeaturetoggleComponent } from "./tabs/sysadm-featuretoggle/sysadm-featuretoggle.component";
import { SysadmGeometriComponent } from "./tabs/sysadm-geometri/sysadm-geometri.component";
import { SysadmKundorderComponent } from "./tabs/sysadm-kundorder/sysadm-kundorder.component";
import { SysadmMiscComponent } from "./tabs/sysadm-misc/sysadm-misc.component";
import { SysadmPrologComponent } from "./tabs/sysadm-prolog/sysadm-prolog.component";
import { SysadmVacsComponent } from "./tabs/sysadm-vacs/sysadm-vacs.component";
import { SysadmVerksamhetsomradenComponent } from "./tabs/sysadm-verksamhetsomraden/sysadm-verksamhetsomraden.component";
import { SysadmViol3Component } from "./tabs/sysadm-viol3/sysadm-viol3.component";
import { SysadmVirkeskopComponent } from "./tabs/sysadm-virkeskop/sysadm-virkeskop.component";
import { SysadmVirkesleverantorerComponent } from "./tabs/sysadm-virkesleverantorer/sysadm-virkesleverantorer.component";
import { SysadmWebinstallningarComponent } from "./tabs/sysadm-webinstallningar/sysadm-webinstallningar.component";

@Component({
    selector: "rask-systemadministration",
    templateUrl: "./systemadministration.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        TabsComponent_1,
        TabComponent,
        SysadmFeaturetoggleComponent,
        SysadmVacsComponent,
        SysadmVirkeskopComponent,
        SysadmKundorderComponent,
        SysadmArbetsorderComponent,
        SysadmGeometriComponent,
        SysadmMiscComponent,
        SysadmPrologComponent,
        SysadmAvverkningsanmalanComponent,
        SysadmViol3Component,
        SysadmVirkesleverantorerComponent,
        SysadmVerksamhetsomradenComponent,
        SysadmWebinstallningarComponent,
        SysadmEudrComponent,
        SysadmChecklistaComponent
    ]
})
export class SystemadministrationComponent implements CanBeDirty {
    hookDeregisterFn: any;
    @ViewChild(TabsComponent) viewChild: TabsComponent;

    isDirtyFn() {
        return this.viewChild.activeTab.deactivate();
    }
}
